import { PageRoute } from '../../types/page.types';
import { AccessRole, StakeholderRole } from '../../types/stakeholder.types';
import { CompanySettingsCardTab } from './company-settings.types';

const BILLING_TABS = new Set<CompanySettingsCardTab>([
  CompanySettingsCardTab.COMPANY_BILLING_HISTORY,
  CompanySettingsCardTab.COMPANY_PLAN_BILLING,
]);

const TAB_VALUES = new Set<string>(Object.values(CompanySettingsCardTab));

export type CompanySettingsAccessCompany = {
  roleInCompany: StakeholderRole;
  stakeholder?: { accessRole?: AccessRole | null };
};

const isGuest = (company?: CompanySettingsAccessCompany | null) =>
  Boolean(company?.stakeholder?.accessRole);

export const canAccessCompanySettings = (
  company?: CompanySettingsAccessCompany | null,
): boolean => {
  if (!company || isGuest(company)) return false;

  return (
    company.roleInCompany === StakeholderRole.ADMIN ||
    company.roleInCompany === StakeholderRole.CONTRIBUTOR
  );
};

export const isCompanySettingsTabVisible = (
  company: CompanySettingsAccessCompany,
  tab: CompanySettingsCardTab,
): boolean => {
  if (!canAccessCompanySettings(company)) return false;
  if (BILLING_TABS.has(tab) && company.roleInCompany !== StakeholderRole.ADMIN) return false;

  return true;
};

export const toCompanySettingsPath = (
  tab: CompanySettingsCardTab = CompanySettingsCardTab.COMPANY_DETAILS,
): string =>
  tab === CompanySettingsCardTab.COMPANY_DETAILS
    ? PageRoute.COMPANY_SETTINGS
    : `${PageRoute.COMPANY_SETTINGS}/${tab}`;

export const companySettingsTabFromPathname = (pathname: string): CompanySettingsCardTab | null => {
  if (pathname === PageRoute.COMPANY_SETTINGS) {
    return CompanySettingsCardTab.COMPANY_DETAILS;
  }

  if (!pathname.startsWith(`${PageRoute.COMPANY_SETTINGS}/`)) {
    return null;
  }

  const tab = pathname.slice(`${PageRoute.COMPANY_SETTINGS}/`.length);
  return TAB_VALUES.has(tab) ? (tab as CompanySettingsCardTab) : null;
};
